import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../../utils/redux';

import { consts as paperworkSubmitAppointmentConsts } from './paperwork-submit-appointment';
import { consts as upcomingSurveyAnswersConsts } from '../../surveys/upcoming-survey-answers';
import { consts as UPCOMING_SURVEY_COMPLETIONS } from '../../surveys/upcoming-survey-completions';
import { consts as cancelVisitReqConsts } from '../../healthboard/requests/cancel-appointment-req';
import { consts as appointmentStatusChangeReqConsts } from '../../healthboard/requests/status-change-req';
import { consts as paymentVerificationConsts } from '../../healthboard/requests/payment-verifications-req';
import { consts as signAppointmentConsentReqConsts } from '../../healthboard/requests/sign-appointment-consent-req';
import { consts as appointmentAccountFormPaymentConsts } from '../../appointmnents/requests/appointment-account-form-payment-req';

export const consts = createReqConsts('paperwork', 'get-appointment-details', [
  'SET_PCP_FORM_DATA',
]);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'paperwork',
  type: 'get',
  slug: [
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentUUID'],
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  switch (action.type) {
    case cancelVisitReqConsts.SUCCEED:
    case appointmentStatusChangeReqConsts.SUCCEED:
    case paperworkSubmitAppointmentConsts.SUCCEED: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case signAppointmentConsentReqConsts.SUCCEED: {
      const consentsAssignment = get(state, 'consentsAssignment', {});

      const { consents = [] } = consentsAssignment || {};

      const newConsents = consents.map(consent => {
        if (consent.id === action.payload.appointmentConsentId) {
          return {
            ...consent,
            accepted: true,
            version: action.payload.version,
          };
        }
        return consent;
      });

      return {
        ...state,
        consentsAssignment: {
          ...consentsAssignment,
          consents: newConsents,
          allSigned: newConsents.every(consent => consent.accepted),
        },
      };
    }

    case upcomingSurveyAnswersConsts.SUCCEED: {
      const surveysAssignments = get(state, 'surveysAssignments', []);

      const newSurveysAssignments = surveysAssignments.map(assignment => {
        if (assignment.id === action.payload.assignmentId) {
          return {
            ...assignment,
            ...action.payload,
          };
        }
        return assignment;
      });

      return {
        ...state,
        surveysAssignments: newSurveysAssignments,
      };
    }

    case consts.SET_PCP_FORM_DATA: {
      const { payload } = action;

      return {
        ...state,
        pcpProviderAnswer: payload.pcpProviderAnswer,
        pcpName: payload.pcpName,
        considerUsPcp: payload.considerUsPcp,
        primaryCareProvider: payload.pcp,
      };
    }

    case appointmentAccountFormPaymentConsts.SUCCEED:
    case paymentVerificationConsts.SUCCEED: {
      const { payload } = action;

      const appointmentId = get(state, 'id', null);

      const payable = get(payload, 'payable', null);

      if (appointmentId && payable) {
        return {
          ...state,
          ...payable,
        };
      }

      return state;
    }

    case UPCOMING_SURVEY_COMPLETIONS.SUCCEED: {
      const { payload } = action;
      const { assignmentId } = payload || {};
      const { surveyAssignments = [] } = state || {};

      if (assignmentId && surveyAssignments.length) {
        const newSurveyAssignments = surveyAssignments.map(assignment => {
          if (assignment.assignmentId === assignmentId) {
            return payload;
          }
          return assignment;
        });

        return {
          ...state,
          surveyAssignments: newSurveyAssignments,
        };
      }

      return state;
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/paperwork/requests/paperwork-get-appointment-details.js